<template>
  <div class="home-contaniner">
    <client-only>
      <LiveHomeView :liveList="homeLiveList" :banners="banners[0]" v-if="homeLiveList.length>0 "></LiveHomeView>
    </client-only>
    <client-only>
      <div class="live-card">
        <div class="card-title-cn">照片直播</div>
        <div class="card-title-en">Live Photo</div>
        <a href="https://live.photoplus.cn/live/34916425" class="card-title-check">{{$t('liveCardCheck')}}</a>
        <img class="card-img" src="~/static/image/live-entry.png" alt="" />
      </div>
    </client-only>
    <client-only>
      <bbs-action-side @openIm="openIm" v-show="actionSide" />
      <xiaozimaIM ref="imRef" />
    </client-only>

    <div class="home-banner-contaniner">
      <a-carousel autoplay>
        <bbs-banner v-for="item in banners" :key="item.id" :data="item"
          v-if="homeLiveList.length<1&&banners.length>0" />
      </a-carousel>
      <div v-if="views" class="home-views">
        {{ $t('views') }}：{{ views }}
      </div>

      <client-only>
        <vue-count-down
          :class="homeLiveList.length>1?'countdown-container countdown-container-bottom':'countdown-container'"
          :count="countdown"
          :style="liveCountDown.start?'background: linear-gradient(0deg, #0D51FF 0%, #4579FF 100%);':''"
          v-if="!$store.state.user.uid||!liveCountDown.start||(liveCountDown.start&&homeLiveList.length<1)">
          <template v-if="!liveCountDown.start">
            <!--            直播开幕式还未开始-->
            <div class="count_down_NotStarted">
              <div class="count_down_NotStarted_title">{{$t('countdown.opening')}}</div>
              <div class="count_down_NotStarted_quantity">
                <div style="color: #111111;margin-right: 20px;font-size: 18px;line-height: 25px">
                  {{$t('countdown.Countdown')}}</div>
                <div style="color: #999;font-size: 14px;line-height: 25px">{{$t('views')}}:{{ $store.state.totalVisit }}
                </div>
              </div>
              <div class="count_down_NotStarted_time">
                <div class="count_down_NotStarted_time_number">{{ day<10?('0'+ day):day}}</div>
                <div class="count_down_NotStarted_time_text">{{$t('countdown.format.day')}}</div>
                <div class="count_down_NotStarted_time_number">{{ hour<10?('0'+hour):hour }}</div>
                <div class="count_down_NotStarted_time_text">{{$t('countdown.format.hour')}}</div>
                <div class="count_down_NotStarted_time_number">{{ minute<10?('0'+minute):minute }}</div>
                <div class="count_down_NotStarted_time_text">{{$t('countdown.format.minute')}}</div>
                <div class="count_down_NotStarted_time_number">{{ second<10?('0'+second):second }}</div>
                <div class="count_down_NotStarted_time_text">{{$t('countdown.format.second')}}</div>
              </div>
              <div class="count_down_NotStarted_btn" @click="playLive">
                {{ $store.state.user.uid?$t('live.viewLive'):$t('enrollNow') }}
              </div>
            </div>
          </template>

          <template v-if="(liveCountDown.start&&!$store.state.user.uid)||(liveCountDown.start&&homeLiveList.length<1)">
            <div class="count_down_NotStarted">
              <div class="count_down_NotStarted_title" style="color: #fff">{{$t('countdown.opening')}}</div>
              <div class="count_down_NotStarted_quantity" style="margin-top: 20px;">
                <div style="color: #fff;margin-right: 20px;font-size: 18px;line-height: 25px">
                  {{$t('countdown.OfficiallyOpened')}}</div>
                <div style="color: #fff;font-size: 14px;line-height: 25px">{{$t('views')}}:{{ $store.state.totalVisit }}
                </div>
              </div>
              <div class="live_time" v-if="$store.state.locale=='zh_CN'">
                {{$t('countdown.liveTime')}} {{ liveCountDown.openingTime|getLiveTime(liveCountDown.endTime) }}
              </div>
              <div class="live_time" v-else>
                {{$t('countdown.liveTime')}} {{ liveCountDown.openingTime|getLiveTimeEn(liveCountDown.endTime) }}
              </div>
              <div class="count_down_NotStarted_btn" style="color: #0D51FF;background: #fff;" @click="playLive">
                {{ $store.state.user.uid?$t('live.viewLive'):$t('enrollNow') }}
              </div>
            </div>
          </template>
          <!--					<a-button block class="countdown-btn" @click="$store.dispatch('enroll')">-->
          <!--						{{ restCount > 0 ? $t('enrollNow') : locales.countdown.watchNow }}-->
          <!--					</a-button>-->

        </vue-count-down>
      </client-only>

    </div>

    <!--    论坛议程-->
    <div class="agendaBox">
      <div class="agenda_title_img">
        <img v-if="$store.state.locale=='zh_CN'" src="../../static/image/agenda/yicheng.png" alt="">
        <img style="width: 247px;height: 80px" v-else src="../../static/image/agenda/yicheng_en.png" alt="">
      </div>
      <Agenda @change="agendaChange">
        <div class="agenda_content_right_content">
          <div class="agenda_content_right_content_item" v-if="agendas.length>0" v-for="(item,index) in agendas"
            :key="index">
            <div class="agenda_content_right_content_item_title">
              <div class="agenda_time">{{item.title}}({{item.startTime}}-{{item.endTime}})</div>
              <div class="more" :ref="'more'+item.id" @click="moreClick(item.id)"
                v-show="item.guests&&item.guests.length>10">
                {{$t('more')}}
                <i class="iconfont icongengduo-zhankai"></i>
                <!--                <i class="iconfont icongengduo-shoulong"></i>-->
              </div>
            </div>

            <div class="guests_list" style="max-height: 600px;">
              <AgendaHead v-for="guestsItem in item.guests" v-if="item.guests.length>0" :key="guestsItem.id"
                :guestsItem="guestsItem"></AgendaHead>
            </div>
            <!--            <div class="guests_list" v-else>-->
            <!--              <AgendaHead v-for="(guestsItem,index) in item.guests" v-if="index<10" :key="guestsItem.id" :guestsItem="guestsItem"></AgendaHead>-->
            <!--            </div>-->

          </div>
        </div>
      </Agenda>
    </div>

    <!--    专家访谈  -->

    <div class="expert" v-if="interviewList.length>0">
      <div class="expert_title_img">
        <img v-if="$store.state.locale=='zh_CN'" src="../../static/image/agenda/zhuanjia.png" alt="">
        <img v-else src="../../static/image/agenda/zhuanjia_en.png" alt="">
      </div>

      <div class="expert_box">
        <div style="text-align: right;margin-bottom: 10px"><a class="expert_box_more"
            :href="$store.state.locale=='en'?'/en/interview':'/interview'">{{$t('live.lookMore')}}<i
              class="iconfont icongengduo"></i></a></div>
        <div class="expert_list">
          <interview-card ref="interview" class="expert_item" v-for="item in interviewList"
            v-if="interviewList.length>0" :key="item.id" :data="item"></interview-card>
        </div>
      </div>
    </div>

    <!--    线下巡回  -->
    <div class="lectureTour" v-if="lectureTourList.length>0">
      <div class="lectureTour_title_img">
        <img v-if="$store.state.locale=='zh_CN'" src="../../static/image/xianxiaxunhui.png" alt="">
        <img v-else src="../../static/image/xianxiaxunhui_en.png" alt="">
      </div>

      <div class="lectureTour_box">
        <div v-if="lectureTourList.length>4" style="text-align: right;margin-bottom: 10px"><a
            class="lectureTour_box_more"
            :href="$store.state.locale=='en'?'/en/videoList?type=1':'/videoList?type=1'">{{$t('live.lookMore')}}<i
              class="iconfont icongengduo"></i></a></div>
        <div class="lectureTour_list">
          <LectureTour class="lectureTour_item" v-for="(item,index) in lectureTourList" v-if="index<4" :key="index"
            :item="item"></LectureTour>
        </div>
      </div>
    </div>


    <!--   往届精彩回顾  -->
    <div class="pastVideo" v-if="pastVideoList.length>0">
      <div class="pastVideo_title_img">
        <img v-if="$store.state.locale=='zh_CN'" src="../../static/image/jingcai.png" alt="">
        <img v-else src="../../static/image/jingcai_en.png" alt="">
      </div>

      <div class="pastVideo_box">
        <div v-if="pastVideoList.length>3" style="text-align: right;margin-bottom: 10px"><a class="pastVideo_box_more"
            :href="$store.state.locale=='en'?'/en/videoList?type=2':'/videoList?type=2'">{{$t('live.lookMore')}}<i
              class="iconfont icongengduo"></i></a></div>
        <div class="pastVideo_list">
          <PastVideo v-for="(item,index) in pastVideoList" v-if="index<3" :key="index" :item="item"></PastVideo>
        </div>
      </div>
    </div>

    <!--    关于论坛    -->
    <div class="forum">
      <div class="forum_title_img">
        <img v-if="$store.state.locale=='zh_CN'" style="width: 224px;height: 79px"
          src="../../static/image/guanyuluntan.png" alt="">
        <img v-else style="width: 209px;height: 81px" src="../../static/image/guanyuluntan_en.png" alt="">
      </div>

      <div class="forum_content">
        <div class="forum_content_left">
          <img :src="forum.coverUrl" :alt="forum.title">
        </div>
        <div class="forum_content_right">
          <div class="forum_content_right_title">{{forum.title}}</div>
          <div class="forum_content_right_describe">
            {{forum.introduce}}
          </div>
          <a class="forum_content_right_btn" :href="$store.state.locale=='en'?'/en/about':'/about'">
            {{$t('introduce')}}
          </a>
        </div>
      </div>
    </div>


    <!--    主办单位-->
    <div class="undertake"
      :style="organizerList.length<6?'justify-content: center;background: #F8F8F8':'background: #F8F8F8'"
      v-if="organizerList.length>0">
      <img v-if="$store.state.locale=='zh_CN'" src="../../static/image/zbdw.png" alt="">
      <img v-else src="../../static/image/zbdw_en.png" alt="">
      <div class="undertake_logo">
        <div class="undertake_logo_item" v-for="item in organizerList" :key="item.id" @click="goFirm(item.id)">
          <div class="undertake_logo_item_img">
            <img ref="img" :src="item.logoUrl" :alt="item.name">
          </div>
          <div class="undertake_logo_item_name" :title="item.name">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <!--    承办单位-->
    <div class="undertake" style="padding-top: 0;"
      :style="undertakerList.length<6?'justify-content: center;background: #F8F8F8':'background: #F8F8F8'"
      v-if="undertakerList.length>0">
      <img v-if="$store.state.locale=='zh_CN'" src="../../static/image/cbdw.png" alt="">
      <img v-else src="../../static/image/cbdw_en.png" alt="">
      <div class="undertake_logo">
        <div class="undertake_logo_item" v-for="item in undertakerList" :key="item.id" @click="goFirm(item.id)">
          <div class="undertake_logo_item_img">
            <img ref="img" :src="item.logoUrl" :alt="item.name">
          </div>
          <div class="undertake_logo_item_name" :title="item.name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!--    执行承办单位,执行单位,协办单位,特别鸣谢    -->
    <div class="undertake" v-if='executeUndertakeList.length>0&&executeUnit.length>0'>
      <!--      执行承办单位-->
      <div v-if='executeUndertakeList.length>0'>
        <img v-if="$store.state.locale=='zh_CN'" style="width: 648px;height: 125px;"
          src="../../static/image/zhixingchengban.png" alt="">
        <img v-else style="width: 650px;height: 125px;" src="../../static/image/zhixingchengban_en.png" alt="">
        <div class="undertake_logo" :style="executeUndertakeList.length<6?'justify-content: center;':''">
          <div class="undertake_logo_item" v-for="item in executeUndertakeList" :key="item.id" @click="goFirm(item.id)">
            <div class="undertake_logo_item_img">
              <img ref="img" :src="item.logoUrl" :alt="item.name">
            </div>
            <div class="undertake_logo_item_name" :title="item.name">{{ item.name }}</div>
          </div>
        </div>
      </div>

      <!--      执行单位-->
      <div v-if="executeUnit.length>0">
        <img v-if="$store.state.locale=='zh_CN'" style="width: 781px;height: 115px;"
          src="../../static/image/zhixing.png" alt="">
        <img v-else style="width: 781px;height: 115px;" src="../../static/image/zhixing_en.png" alt="">
        <div class="undertake_logo" :style="executeUnit.length<6?'justify-content: center;':''">
          <div class="undertake_logo_item" v-for="item in executeUnit" v-if="executeUnit.length>0" :key="item.id"
            @click="goFirm(item.id)">
            <div class="undertake_logo_item_img">
              <img ref="img" :src="item.logoUrl" :alt="item.name">
            </div>
            <div class="undertake_logo_item_name" :title="item.name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>


    <!--    协办单位-->
    <div class="undertake"
      :style="assistUnit.length<6?'justify-content: center;background: #F8F8F8':'background: #F8F8F8'"
      v-if="assistUnit.length>0">
      <img v-if="$store.state.locale=='zh_CN'" style="width: 358px;height: 81px;" src="../../static/image/xieban.png"
        alt="">
      <img v-else style="width: 363px;height: 83px;" src="../../static/image/xieban_en.png" alt="">
      <div class="undertake_logo">
        <div class="undertake_logo_item" v-for="item in assistUnit" :key="item.id" @click="goFirm(item.id)">
          <div class="undertake_logo_item_img">
            <img ref="img" :src="item.logoUrl" :alt="item.name">
          </div>
          <div class="undertake_logo_item_name" :title="item.name">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <!--    特别鸣谢-->
    <div class="undertake" v-if="thanks.length>0">
      <img v-if="$store.state.locale=='zh_CN'" style="width: 456px;height: 80px;"
        src="../../static/image/tebiemingxie.png" alt="">
      <img v-else style="width: 456px;height: 81px;" src="../../static/image/tebiemingxie_en.png" alt="">
      <div class="undertake_logo" :style="thanks.length<6?'justify-content: center;':''">
        <div class="undertake_logo_item" v-for="item in thanks" :key="item.id" @click="goFirm(item.id)">
          <div class="undertake_logo_item_img">
            <img ref="img" :src="item.logoUrl" :alt="item.name">
          </div>
          <div class="undertake_logo_item_name" :title="item.name">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <!--    底部横幅-->
    <div class="bottom_img" v-if="bottomBanner.length>0">
      <img ref="img" style="width: 100%" :src="bottomBanner[0].coverUrl" alt="">
    </div>
  </div>
</template>

<script>
  // 组件采用懒加载方式
  const VueCountDown = () => import('@liuwave/vue-count-down')
  const BbsVideoCard = () => import('@/components/common/bbs-video-card')
  const BbsGuestCard = () => import('@/components/common/bbs-guest-card')
  const LiveSideNotice = () => import('@/components/LiveSideNotice');
  const LiveHomeView = () => import('@/components/LiveHomeView')
  const BbsActionSide = () => import('@/components/layout/bbs-action-side')
  import interviewCard from '../../components/interviewCard/index'
  import Agenda from "../../components/Agenda";
  import AgendaHead from "../../components/AgendaHead";
  import BbsBanner from '@/components/common/bbs-banner';
  import xiaozimaIM from "@/components/xiaozimaIM";
  import LectureTour from "../../components/LectureTour/LectureTour";
  import PastVideo from "../../components/PastVideo/PastVideo";
  import { mapState } from "vuex";
  import objectFitImages from 'object-fit-images'
  export default {
    name: 'Home',
    components: {
      BbsGuestCard,
      BbsVideoCard,
      BbsBanner,
      VueCountDown,
      LiveSideNotice,
      LiveHomeView,
      Agenda,
      AgendaHead,
      interviewCard,
      BbsActionSide,
      xiaozimaIM,
      LectureTour,
      PastVideo
    },
    head() {
      return this.$store.state.head
    },
    computed: {
      ...mapState(['user'])
    },
    data() {
      const me = this
      return {
        countdown: 0,
        liveCountDown: {},
        actionSide: false,
        timer: null,
        views: null,
        interIndex: 1,
        organizerList: [],//主办单位
        undertakerList: [],//承办单位
        executeUndertakeList: [], //执行承办单位
        executeUnit: [],// 执行单位
        assistUnit: [],//协办单位
        thanks: [],// 特别鸣谢
        banners: [],
        dates: [],
        lives: [],
        agendas: [],
        agendaFlag: false,
        expanded: {},
        linksTypes: [],
        linksGroup: {},
        videos: [],
        startTime: null,
        activeDate: null,
        activeAgenda: null,
        forum: {},
        advertisement: [],
        interviewList: [],
        loading: {
          live: false,
          agenda: false
        },
        agendaPagination: {
          pageSize: 2,
          hideOnSinglePage: true,
          onChange() {
            for (let key in me.expanded) {
              me.expanded[key] = false
            }
          }
        },
        locales: {
          agenda: this.$t('agenda'),
          countdown: this.$t('countdown')
        },
        homeLiveList: [],
        day: 0,
        hour: 0,
        minute: 0,
        second: 0,
        bottomBanner: [],
        lectureTourList: [],
        pastVideoList: []
      }
    },
    filters: {
      getLiveTime(s, e) {
        return `${s.split(' ')[0].split('-')[1]}月${s.split(' ')[0].split('-')[2]}日-${e.split(' ')[0].split('-')[2]}日`
      },
      getLiveTimeEn(s, e) {
        let date = new Date(s).toDateString()
        let endDay = new Date(e).getDate()
        let arr = date.split(' ')
        return `${arr[1]} ${arr[2]}-${endDay} ${arr[3]}`
      }
    },
    destroyed() {

    },
    async mounted() {
      objectFitImages(this.$refs.img)
      window.addEventListener('scroll', this.getScroll);
      this.getInitData()
      await this.init()
      await this.agendaCurrent();
      await this.getUnitData()
      this.getScroll()
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.getScroll);
      // 页面销毁时，销毁定时器
      clearInterval(this.timer)
    },
    methods: {
      async getInitData() {
        // baners图 顶部
        const { data } = await this.$axios.$get('/forum/banner/list', {
          params: {
            platform: 1,
            position: 1
          }
        })
        this.banners = data
        // 底部
        const { data: bottom } = await this.$axios.$get('/forum/banner/list', {
          params: {
            platform: 1,
            position: 2
          }
        })
        this.bottomBanner = bottom

        // 专家访谈
        const { data: interview } = await this.$axios.$get('/forum/interview/list/page')
        this.interviewList = interview.list

        // 线下巡回
        const { data: lectureTour } = await this.$axios.$get('/forum/video/list/page', { params: { type: 1 } })
        this.lectureTourList = lectureTour.list

        // 往届回顾
        const { data: pastVideo } = await this.$axios.$get('/forum/video/list/page', { params: { type: 2 } })
        this.pastVideoList = pastVideo.list

        // 关于论坛
        const { data: forum } = await this.$axios.get('/forum/article', { params: { type: 1 } })
        this.forum = forum.data
      },
      openIm() {
        this.$refs.imRef.openIm()
      },
      getScroll() {
        if (!!document.documentElement.scrollTop && document.documentElement.scrollTop >= 800) {
          if (this.actionSide) return
          this.actionSide = true
        } else {
          if (!this.actionSide) return
          this.actionSide = false
        }
      },
      moreClick(id) {
        if (this.$refs['more' + id][0].parentNode.parentNode.childNodes[2].style.maxHeight.split('p')[0] > 600) {
          this.$refs['more' + id][0].parentNode.parentNode.childNodes[2].style.maxHeight = '600px'
          this.$refs['more' + id][0].parentNode.childNodes[2].childNodes[1].className = 'iconfont icongengduo-zhankai'
        } else {
          this.$refs['more' + id][0].parentNode.parentNode.childNodes[2].style.maxHeight = '9000px'
          this.$refs['more' + id][0].parentNode.childNodes[2].childNodes[1].className = 'iconfont icongengduo-shoulong'
        }
        // if(!this.agendaFlag){
        //   e.target.parentNode.parentNode.childNodes[2].style.cssText = 'max-height:9999px'
        //   e.target.parentNode.childNodes[2].childNodes[1].className = 'iconfont icongengduo-shoulong'
        //   // iconfont icongengduo-shoulong
        // }else{
        //   e.target.parentNode.parentNode.childNodes[2].style.cssText = 'max-height:600px'
        //   e.target.parentNode.childNodes[2].childNodes[1].className = 'iconfont icongengduo-zhankai'
        // }
        //
        // this.agendaFlag = !this.agendaFlag
      },
      playLive() {
        if (this.$store.state.user.uid) {
          this.$router.push(
            {
              path: this.$store.state.locale == 'en' ? '/en/live' : '/live'
            }
          )
        } else {
          this.$store.dispatch('loginVisible', true)
        }
      },
			/**
			 * @method 获取当前直播数据
			 * @date: 赵亚杰 2021/9/8 0008
			 */
      async agendaCurrent() {
        let res = await this.$axios.get(`/forum/agenda/current`);
        let { code, data } = res.data;
        if (code == 0) {
          this.homeLiveList = data;
        }
      },
      async getUnitData() {
        // 主办单位
        const { data: organizerList } = await this.$axios.get('/forum/org/list', { params: { type: 6 } }) //6
        this.organizerList = organizerList.data
        // 承办单位
        const { data: undertakerList } = await this.$axios.get('/forum/org/list', { params: { type: 7 } }) //7
        this.undertakerList = undertakerList.data
        // 执行承办单位
        const { data } = await this.$axios.get('/forum/org/list', { params: { type: 1 } })  //1
        this.executeUndertakeList = data.data
        // 执行单位
        const { data: executeUnit } = await this.$axios.get('/forum/org/list', { params: { type: 2 } }) //2
        this.executeUnit = executeUnit.data
        // 协助单位
        const { data: assistUnit } = await this.$axios.get('/forum/org/list', { params: { type: 4 } })
        this.assistUnit = assistUnit.data
        // 特别鸣谢
        const { data: thanks } = await this.$axios.get('/forum/org/list', { params: { type: 3 } })
        this.thanks = thanks.data
      },
      async agendaChange(id) {
        const { data } = await this.$axios.get(`/forum/agenda/pid/${id}`)
        this.agendas = data.data
      },
      async init() {
        const me = this;
        const { data } = await this.$axios.get('/forum/common/opening')
        this.$store.commit('SET_VISIT', data.data.totalVisit)
        this.liveCountDown = data.data
        let futureTime = new Date(this.liveCountDown.openingTime.replace(/-/g, "/"))
        let nowTime = new Date(this.liveCountDown.curTime.replace(/-/g, '/'))
        let t = futureTime.getTime() - nowTime.getTime()
        // 获取开幕式倒计时
        if (!this.liveCountDown.start) {
          let inter = setInterval(() => {
            t -= 1000
            this.day = Math.floor(t / 1000 / 60 / 60 / 24);
            this.hour = Math.floor(t / 1000 / 60 / 60 % 24);
            this.minute = Math.floor(t / 1000 / 60 % 60);
            this.second = Math.floor(t / 1000 % 60);
            if (t < 1000) {
              this.day = 0
              this.hour = 0
              this.minute = 0
              this.second = 0
              clearInterval(inter)
              this.init()
              this.agendaCurrent()
            }


          }, 1000)
        }
      },
      getViews() {
        const me = this

        me.$axios.$get(`count?plus=${me.$store.state.viewsPlus}`).then(res => me.views = res.data.value)
          .catch(() => clearInterval(me.timer)).finally(() => me.$store.commit('SET_VIEWS_PLUS', false))
      },
      getLivesByPid(pid) {
        const me = this
        me.activeAgenda = pid
        me.loading.live = true
        me.$axios.$get(`agenda/livesByPid/${pid}`).then(res => me.lives = Object.freeze(res.data)).finally(() => me.loading.live = false)
      },
      onClickToLiveRoom() {
        const me = this
        me.$store.dispatch('enroll', { date: me.activeDate, active: me.activeAgenda })
      },
      onClickToChangeCollapse({ id }) {
        const me = this, $dom = me.$refs[id]

        if ($dom) {
          const { clientHeight, scrollHeight } = $dom
          $dom.style.maxHeight = clientHeight < scrollHeight ? scrollHeight + 'px' : '330px'
          me.$set(me.expanded, id, $dom.clientHeight < scrollHeight)
        }
      },
      goFirm(id) {
        this.$router.push({
          path: this.$store.state.locale == 'en' ? '/en/firm' : '/firm',
          query: {
            id: id
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .live-card {
    position: fixed;
    z-index: 1;
    bottom: 60px;
    left: 20px;
    width: 150px;
    height: 180px;
    display: flex;
    background: #fff;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, .25);
    border-radius: 4px;
    justify-content: center;

    .card-title-cn,
    .card-title-en {
      color: #333;
      font-size: 16px;
      line-height: 25px;
    }

    .card-title-check {
      width: 77px;
      height: 26px;
      background: #0D51FF;
      border-radius: 3px;
      font-size: 12px;
      color: #fff;
      line-height: 26px;
      text-align: center;
      margin-top: 5px;
      margin-bottom: 10px;
      cursor: pointer;
    }

    .card-img {
      width: 70px;
      height: 70px;
      object-fit: cover;
    }
  }

  .undertake {
    text-align: center;
    padding-top: 75px;

    .undertake_logo {
      padding-top: 40px;
      padding-bottom: 80px;
      width: 1200px;
      height: auto;
      margin: auto;
      display: flex;
      flex-wrap: wrap;

      justify-content: center;

      .undertake_logo_item {
        width: 180px;
        margin-right: 20px;
        margin-bottom: 15px;
        cursor: pointer;

        .undertake_logo_item_img {
          display: flex;
          flex-direction: column;
          justify-content: center;
          background: #fff;
          width: 180px;
          height: 80px;
          overflow: hidden;

          img {
            width: 100%;
            //height: 100%;
          }
        }

        .undertake_logo_item_img:hover {
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.16);
        }

        .undertake_logo_item_name {
          width: 180px;
          height: 40px;
          font-size: 14px;
          padding: 0 5px;
          text-align: center;
          margin-top: 10px;
          color: #999;
          //word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }

      .undertake_logo_item:nth-child(6n+0) {
        margin-right: 0;
      }
    }
  }

  .forum {
    background: #F8F8F8;
    width: 100%;
    height: 100%;
    padding-bottom: 50px;

    .forum_title_img {
      text-align: center;
      background: #F8F8F8;
      ;
      margin-bottom: 70px;
    }

    .forum_content {
      width: 1200px;
      height: auto;
      margin: auto;
      height: 420px;
      display: flex;

      .forum_content_left {
        position: relative;
        width: 840px;
        height: 100%;

        //border: 1px solid rebeccapurple;
        img {
          position: absolute;
          width: 840px;
          height: 360px;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .forum_content_right {
        position: relative;
        width: 360px;
        height: 100%;
        background: #FFFFFF;
        //border: 1px solid red;
        padding: 0 15px;
        padding-left: 20px;
        border-radius: 6px;

        .forum_content_right_title {
          color: #111111;
          font-size: 22px;
          margin-top: 25px;
          font-family: Source Han Sans CN;
          font-weight: bold;
        }

        .forum_content_right_describe {
          height: 190px;
          color: #666666;
          font-size: 16px;
          margin-top: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 8;
          overflow: hidden;
        }

        .forum_content_right_btn {
          position: absolute;
          bottom: 50px;
          left: 40px;
          width: 240px;
          height: 46px;
          text-align: center;
          line-height: 46px;
          color: #fff;
          font-size: 18px;
          background: #0D51FF;
          box-shadow: 0px 6px 7px 0px rgba(13, 81, 255, 0.26), 0px 3px 13px 0px rgba(255, 255, 255, 0.32);
          border-radius: 23px;
          cursor: pointer;
        }
      }
    }
  }

  .expert {
    background: #F8F8F8;
    width: 100%;
    height: 100%;

    .expert_title_img {
      text-align: center;
      width: 100%;
      padding: 50px 0;
      padding-bottom: 10px;

      img {
        width: 358px;
        height: 80px;
      }
    }

    .expert_box {
      width: 1200px;
      height: auto;
      margin: auto;

      .expert_box_more {
        line-height: 22px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #0D51FF;
        margin-top: -2px;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      .expert_list {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 50px;

        .expert_item {
          margin-right: 10px;
          margin-bottom: 10px;
        }

        .expert_item:nth-child(5n+0) {
          margin-right: 0;
        }
      }
    }
  }

  .lectureTour {
    padding-top: 80px;
    padding-bottom: 50px;

    .lectureTour_title_img {
      margin: auto;
      text-align: center;
    }

    .lectureTour_box {
      margin: auto;
      width: 1200px;

      .lectureTour_box_more {
        line-height: 22px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #0D51FF;
        margin-top: -2px;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      .lectureTour_list {
        display: flex;

        .lectureTour_item {
          margin-right: 7px;
        }

        .lectureTour_item:nth-child(4n+0) {
          margin-right: 0;
        }
      }
    }
  }

  .pastVideo {
    padding-top: 80px;
    padding-bottom: 79px;
    background: #F8F8F8;
    width: 100%;
    height: 100%;

    .pastVideo_title_img {
      margin: auto;
      text-align: center;
    }

    .pastVideo_box {
      margin: auto;
      width: 1200px;

      .pastVideo_box_more {
        line-height: 22px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #0D51FF;
        margin-top: -2px;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      .pastVideo_list {
        display: flex;

        .pastVideo_item {
          margin-right: 10px;
        }

        .pastVideo_item:nth-child(3n+0) {
          margin-right: 0;
        }
      }
    }
  }


  .agendaBox {
    width: 100%;
    background: #FFFFFF;
    height: 100%;
    background: url("../../static/image/agenda/LOGO.png");
    background-size: auto;

    .agenda_title_img {
      position: relative;
      width: 1201px;
      height: 200px;
      margin: auto;
      text-align: center;
      background: #fff;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 247px;
        height: 78px;
      }
    }
  }

  .agenda_content_right_content {
    height: 679px;
    width: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
      height: 1px;
      background: #EEEEEE;
    }

    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #999;

    }

    .agenda_content_right_content_item_title {
      display: flex;
      font-size: 18px;
      justify-content: space-between;
      margin-top: 10px;

      .agenda_time {
        color: #333333;
        font-weight: bold;
        flex: 1;
        font-size: 16px;
      }

      .more {
        color: #0D51FF;
        margin-right: 20px;
        cursor: pointer;
        user-select: none;
        font-size: 14px;
      }
    }

    .guests_list {

      overflow: hidden;
      margin-top: 35px;
      display: flex;
      flex-wrap: wrap;

      /deep/.guests_item {
        margin-bottom: 75px;
        margin-right: 50px;
      }

      /deep/.guests_item:nth-child(5n+0) {
        margin-right: 0;
      }
    }


    .guests_list_unfold {
      overflow: auto !important;
    }


  }


  .home-contaniner {
    position: relative;

    //> div:nth-child(odd) {
    //	background: #F4F4F6;
    //}

    .ant-page-header.container {
      padding: 0;

      ::v-deep>.ant-page-header-heading {
        position: relative;

        .ant-page-header-heading-title {
          float: initial;
          font-size: 30px;
          font-weight: 500;
          line-height: 36px;
          text-align: center;
        }

        .ant-page-header-heading-extra {
          top: 0;
          right: 0;
          position: absolute;

          .ant-btn {
            width: 110px;
            height: 36px;
          }
        }
      }

    }

    ::v-deep {
      .slick-dots li {
        margin: 0 5px;

        button {
          width: 42px;
          height: 6px;
          border-radius: 2px;
        }
      }
    }

    .home-banner-contaniner {
      position: relative;
      background: white;

      .ant-carousel ::v-deep {
        .slick-dots-bottom {
          margin-bottom: 30px;
        }

        .banner-img {
          width: 100%;
          height: 100%;
          max-height: 700px;
        }
      }

      .home-views {
        left: 18%;
        bottom: 1.5%;
        color: white;
        font-size: 28px;
        font-weight: 500;
        position: absolute;
      }

      .countdown-container {
        box-sizing: border-box;
        right: 25px;
        bottom: 0;
        z-index: 99;
        color: white;
        width: 420px;
        height: 250px;
        //padding: 20px;
        font-weight: bold;
        position: absolute;
        overflow: hidden;
        display: inline-block;
        box-shadow: inset 0px -5px 6px 0px rgba(0, 0, 0, 0.08);
        border-radius: 6px 6px 0px 0px;
        background: url("../../static/image/countDownBg.png") no-repeat center center;
        background-color: #fff;

        .count_down_NotStarted {
          width: 100%;
          height: 100%;
          //background: #FFFFFF;
          padding: 18px 0;

          .count_down_NotStarted_title {
            color: #111111;
            text-align: center;
            font-size: 18px;
            font-weight: 700;
          }

          .count_down_NotStarted_quantity {
            height: 25px;
            display: flex;
            justify-content: center;
            margin-top: 10px;

          }

          .count_down_NotStarted_time {
            display: flex;
            justify-content: center;
            margin-top: 10px;

            .count_down_NotStarted_time_number {
              width: 44px;
              height: 54px;
              background: #EEF3FF;
              box-shadow: 0px 6px 7px 0px rgba(13, 81, 255, 0.19);
              border-radius: 5px;
              color: #0D51FF;
              font-size: 32px;
              line-height: 54px;
              text-align: center;
              font-weight: 400;
              /*font-style: italic*/
            }

            .count_down_NotStarted_time_text {
              color: #111111;
              font-size: 14px;
              font-weight: bold;
              padding-top: 38px;
              padding-left: 6px;
              padding-right: 10px;
            }

          }

          .count_down_NotStarted_btn {
            width: 200px;
            height: 40px;
            background: #0D51FF;
            box-shadow: 0px 6px 7px 0px rgba(13, 81, 255, 0.26), 0px 3px 13px 0px rgba(255, 255, 255, 0.32);
            border-radius: 20px;
            font-size: 18px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            margin: auto;
            margin-top: 20px;
            cursor: pointer;
          }

          .count_down_NotStarted_btn2 {
            width: 200px;
            height: 40px;
            background: #FFFFFF;
            box-shadow: 0px 6px 10px 0px rgba(13, 81, 255, 0.4);
            border-radius: 20px;
            font-size: 18px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            margin: auto;
            margin-top: 20px;
            cursor: pointer;
          }


          .live_time {
            color: #fff;
            font-size: 24px;
            font-weight: bold;
            text-align: center;
            margin-top: 15px;
          }
        }

        .countdown-title {
          color: #fff;
          height: 60px;
          font-size: 24px;
          font-weight: 500;
          line-height: 22px;
          text-align: center;
        }

        .countdown-live-time {
          height: 65px;
          font-size: 20px;
          text-align: center;
        }

        .countdown-wrapper {
          width: 100%;
          margin: 0 auto;
          font-size: 16px;
          text-align: center;
          table-layout: fixed;
          border-collapse: collapse;

          td {
            width: 25%;
            height: 65px;
            vertical-align: baseline;

            .countdown-number {
              height: 30px;
              font-size: 30px;
              font-weight: 800;
              line-height: 30px;
            }
          }
        }

        .countdown-btn {
          height: 35px;
          border: none;
          color: #BC0B27;
          line-height: 35px;
          font-size: 16px;
          font-weight: bold;
          background: white;
        }
      }

      .countdown-container-bottom {
        bottom: 80px;
      }
    }

    .home-agenda-container {
      padding: 50px 0;
      position: relative;

      .home-agenda-tabs {
        border: none;

        ::v-deep> {
          .ant-card-body {
            padding: 1px 0;
          }

          .ant-card-head {
            padding: 0;

            .ant-tabs-nav {
              display: block;

              >div {
                display: flex;
                justify-content: space-between;

                .ant-tabs-tab {
                  margin: 0;
                  color: #BC0B27;
                  font-size: 30px;
                  font-weight: 500;
                  padding: 0 0 5px;

                  &.ant-tabs-tab-active {
                    border-bottom: 4px solid #BC0B27;
                  }
                }
              }

              .ant-tabs-ink-bar {
                display: none !important;
              }
            }
          }
        }

        .home-agenda-item-tabs {
          border: none;

          ::v-deep> {
            .ant-card-head {
              border: none;
              padding: 20px 0;

              .ant-tabs-bar {
                margin: 0;
                border: none;

                .ant-tabs-nav {
                  height: 82px;

                  .ant-tabs-tab {
                    height: 60px;
                    line-height: 60px;
                    color: #666666;
                    font-size: 20px;
                    font-weight: 500;
                    padding: 0 25px;
                    background: #E0E0E0;
                    border-radius: 10px;
                    transition: none;

                    &.ant-tabs-tab-active {
                      color: white;
                      background: #BC0B27;

                      &:after {
                        content: "";
                        top: 60px;
                        left: calc(50% - 25px);
                        position: absolute;
                        border-top: 20px solid #BC0B27;
                        border-left: 25px solid transparent;
                        border-right: 25px solid transparent;
                      }
                    }
                  }

                  .ant-tabs-ink-bar {
                    display: none !important;
                  }
                }
              }
            }

            .ant-card-body {
              padding: 0;

              .home-agenda-list {

                .ant-list-item {
                  border: none;
                  padding: 0;
                }

                .ant-pagination {
                  text-align: center;
                  margin-bottom: 20px;

                  li:first-child,
                  li:last-child {
                    display: none;
                  }

                  .ant-pagination-item {
                    width: 50px;
                    height: 6px;
                    border: none;
                    border-radius: 3px;
                    background: #BBBBBB;

                    &.ant-pagination-item-active {
                      background: #BC0B27;
                    }

                    a {
                      display: none;
                    }
                  }
                }
              }
            }
          }
        }

        .home-agenda-live-header {
          padding: 12px 30px;

          .home-agenda-live-title {
            font-size: 20px;
            font-weight: bold;
          }

          .ant-btn {
            float: right;
            border: none;
            box-shadow: none;

            &:after {
              content: none;
            }

            ::v-deep .anticon svg {
              transition: all .3s;
            }
          }
        }

        .home-agenda-guest-wrapper {
          padding: 0 10px;
          overflow: hidden;
          max-height: 330px;
          transition: max-height .5s;

          >div {
            width: 20%;
            float: left;
            padding: 5px;
          }
        }
      }

      .home-agenda-enroll-btn {
        width: 160px;
        display: block;
        margin: 20px auto 0;
      }
    }

    .home-interview-container {
      padding: 50px 0;

      .home-interview-carousel {
        margin-top: 50px;
        margin-right: -20px;

        .home-interview-item {
          padding-right: 20px;
        }
      }

      .interview-btn-group {
        margin-top: 40px;
        text-align: center;

        .ant-btn {
          width: 60px;
          height: 30px;
          margin: 0 10px;
        }
      }
    }

    .home-links-container {
      padding: 50px 0;

      .home-links-wrapper {
        margin-bottom: 40px;

        blockquote {
          height: 30px;
          font-size: 20px;
          line-height: 30px;
          font-weight: 500;
          padding-left: 20px;
          border-left: 5px solid #BC0B27;
        }
      }

      .home-links-item {
        width: 182px;
        margin: 20px 9px 0;
        vertical-align: top;
        display: inline-block;

        .home-links-img-wrapper {
          display: block;
          background: white;
          border: 1px solid #EAEAEC;

          >img {
            width: 180px;
            height: 80px;
            object-fit: fill;
          }
        }

        .home-links-name {
          margin-top: 10px;
          max-height: 40px;
          overflow: hidden;
          white-space: normal;
          //word-break: break-word;
          text-align: center;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }

    .home-footer-banner {
      padding: 120px 0;

      ::v-deep {
        .slick-dots-bottom {
          margin-bottom: 15px;
        }

        .banner-img {
          width: 100%;
          margin: 0 auto;
          max-height: 180px;
          object-fit: contain;
        }
      }
    }
  }

  .bottom_img {
    min-width: 1200px;
  }

  img {
    object-fit: cover;
    font-family: "object-fit: contain;";
  }

  .icongengduo {
    font-size: 20px;
  }
</style>